export default [
    {
        path: '/system/email-settings',
        name: 'email-settings',
        component: () => import('../../pages/system/EmailSettingsPage.vue'),
        meta: {
            title: 'Email Settings',
            requiresAuth: true,
        },
    },
]
